import { render, staticRenderFns } from "./Alteration.vue?vue&type=template&id=63c12498&scoped=true&"
import script from "./Alteration.vue?vue&type=script&lang=js&"
export * from "./Alteration.vue?vue&type=script&lang=js&"
import style0 from "./Alteration.vue?vue&type=style&index=0&id=63c12498&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c12498",
  null
  
)

export default component.exports